'use client';

import classNames from '@sindresorhus/class-names';
import type {PropsWithChildren} from 'react';

import styles from './Marquee.module.scss';

export type MarqueeProps = PropsWithChildren<{
  marqueeSpeed: number;
  className?: string;
}>;

const MARQUEE_ITEM_COUNT = 4;

export const Marquee = ({marqueeSpeed, children, className}: MarqueeProps) => {
  const MarqueeItem = () => (
    <div className={styles.itemsList} aria-hidden={true} tabIndex={-1}>
      {children}
    </div>
  );

  return (
    <div
      className={classNames(
        styles.marquee,
        {
          [styles[`marqueeSpeed${marqueeSpeed}`]]: marqueeSpeed !== undefined,
        },
        className,
      )}
    >
      <div className={styles.marqueeWrapper}>
        {Array(MARQUEE_ITEM_COUNT)
          .fill(MarqueeItem)
          .map((Marquee, index) => (
            <Marquee key={index} />
          ))}
      </div>
    </div>
  );
};
